// library imports
import { useState, useEffect, useContext } from "react";
import { Tooltip, Skeleton, Empty, Flex } from "antd";
import { InfoCircleOutlined } from "@ant-design/icons";
import { useNavigate } from "react-router-dom";
// style imports
import "../../styles/Dashboard/PVConditionAlarmContent.css";
// hook imports
import useFetch from "../../hooks/useFetch";
// context imports
import { IndexContext } from "../../context/IndexContext";
// config imports
import { MQTT_REFRESH_RATE } from "../../configs/configs";
// component imports
import DoughnutChart from "../common/DoughnutChart";
import EmptyDoughnutChart from "../common/EmptyDoughnutChart";

export default function AlarmContent({ setRefreshCheck }) {
  const navigate = useNavigate();

  const [fetchWrapper] = useFetch();
  const { siteSelected, notificationApi } = useContext(IndexContext);

  const [loading, setLoading] = useState(true);

  const [data, setData] = useState([]);

  function valueFormatter(value) {
    return value.toLocaleString({
      maximumFractionDigits: 2,
      minimumFractionDigits: 2,
    });
  }

  function getAlarmData() {
    fetchWrapper({
      endpoint_url: "dashboard/getAlarmData",
      method: "GET",
      set_content_type_header: false,
      params: {
        site_id: siteSelected,
      },

      onSuccess: (response) => {
        setData(response.data);
        setRefreshCheck(true);
      },
      onResponseError: (response) => {
        notificationApi.error({
          message: "Failed to get alarm data.",
          description: response.statusText,
        });
      },

      onFinish: () => {
        setLoading(false);
      },
    });
  }

  useEffect(() => {
    if (siteSelected) {
      setLoading(true);
      getAlarmData();

      const timer = setInterval(() => {
        getAlarmData();
      }, MQTT_REFRESH_RATE * 1000);

      return () => {
        clearInterval(timer);
      };
    }
  }, [siteSelected]);

  return (
    <div className="h-100 w-100">
      {loading === false ? (
        data.length === 0 ? (
          <Flex align="center" justify="center" className="h-100 w-100">
            <Empty />
          </Flex>
        ) : data.every((item) => item.value === 0) ? (
          <EmptyDoughnutChart data={[{ type: "Alarm", percent: 0 }]} />
        ) : (
          <div style={{ height: "inherit" }}>
            {/* Temporarily disabled first, TODO: need to fix alarm */}
            {/* <div style={{ height: "5%", position: "absolute", right: "12px" }}>
              <Tooltip title="Click me to navigate to alarm page.">
                <InfoCircleOutlined
                  style={{ color: "red" }}
                  onClick={() => {
                    navigate("/Alarm/AlarmRecord");
                  }}
                />
              </Tooltip>
            </div> */}
            <div style={{ height: "95%" }}>
              <DoughnutChart
                data={data}
                y="value"
                color="name"
                innerRadius={0.55}
                outerRadius={0.8}
                statisticValueFormatter={(d) => valueFormatter(d)}
                yValueFormatter={(d) => valueFormatter(d)}
              />
            </div>
          </div>
        )
      ) : (
        <Skeleton
          active={true}
          style={{ padding: "0.4rem", maxWidth: "70%", margin: "auto" }}
          paragraph={{ rows: 4 }}
        />
      )}
    </div>
  );
}

// old code
// // library imports
// import { useState, useEffect, useContext } from "react";
// import { Tooltip, Card, Skeleton } from "antd";
// import { InfoCircleOutlined } from "@ant-design/icons";
// import { useNavigate } from "react-router-dom";
// // style imports
// import "../../styles/Dashboard/PVConditionAlarmContent.css";
// // hook imports
// import useFetch from "../../hooks/useFetch";
// // context imports
// import { IndexContext } from "../../context/IndexContext";
// // config imports
// import { MQTT_REFRESH_RATE } from "../../configs/configs";

// export default function AlarmContent({ setRefreshCheck }) {
//   const navigate = useNavigate();

//   const [fetchWrapper] = useFetch();
//   const { siteSelected, notificationApi } = useContext(IndexContext);

//   const [loading, setLoading] = useState(true);

//   const [online, setOnline] = useState(0);
//   const [offline, setOffline] = useState(0);
//   const [warning, setWarning] = useState(0);
//   const [error, setError] = useState(0);

//   function getAlarmData() {
//     fetchWrapper({
//       endpoint_url: "dashboard/getAlarmData",
//       method: "GET",
//       set_content_type_header: false,
//       params: {
//         site_id: siteSelected,
//       },

//       onSuccess: (response) => {
//         setOnline(response.data.online_count);
//         setOffline(response.data.offline_count);
//         setWarning(response.data.warning_count);
//         setError(response.data.error_count);
//         setRefreshCheck(true);
//       },
//       onResponseError: (response) => {
//         notificationApi.error({
//           message: response.message,
//         });
//       },

//       onFinish: () => {
//         setLoading(false);
//       },
//     });
//   }

//   useEffect(() => {
//     if (siteSelected) {
//       getAlarmData();

//       const timer = setInterval(() => {
//         getAlarmData();
//       }, MQTT_REFRESH_RATE * 1000);

//       return () => {
//         clearInterval(timer);
//       };
//     }
//   }, [siteSelected]);

//   return (
//     <>
//       {loading === false ? (
//         <div className="pvcondition-alarm-content-container">
//           <span>
//             Devices Offline: {offline}
//             {offline !== "-" && offline !== 0 && (
//               <Tooltip title="Click me to navigate to alarm page.">
//                 <InfoCircleOutlined
//                   style={{ color: "#FF0000" }}
//                   onClick={() => {
//                     navigate("/Alarm/AlarmRecord");
//                   }}
//                 />
//               </Tooltip>
//             )}
//           </span>

//           <span>
//             Has Warning: {warning}
//             {warning !== "-" && warning !== 0 && (
//               <Tooltip title="Click me to navigate to alarm page.">
//                 <InfoCircleOutlined
//                   style={{ color: "#E4D00A" }}
//                   onClick={() => {
//                     navigate("/Alarm/AlarmRecord");
//                   }}
//                 />
//               </Tooltip>
//             )}
//           </span>

//           <span>
//             Has Error: {error}
//             {error !== "-" && error !== 0 && (
//               <Tooltip title="Click me to navigate to alarm page.">
//                 <InfoCircleOutlined
//                   style={{ color: "#E4D00A" }}
//                   onClick={() => {
//                     navigate("/Alarm/AlarmRecord");
//                   }}
//                 />
//               </Tooltip>
//             )}
//           </span>
//         </div>
//       ) : (
//         <Card
//           size="small"
//           style={{
//             width: "100%",
//             height: "100%",
//           }}
//           className="alarm-card"
//         >
//           <Skeleton
//             active={true}
//             style={{ padding: "0.4rem", maxWidth: "70%", margin: "auto" }}
//             paragraph={{ rows: 1 }}
//           />
//         </Card>
//       )}
//     </>
//   );
// }
